import { render } from "./warehouse-create.vue?vue&type=template&id=eefe7134"
import script from "./warehouse-create.vue?vue&type=script&lang=js"
export * from "./warehouse-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__